import { Injectable } from '@angular/core';
import { IAuthentication, IExposeAuthentication, ISession } from 'projects/common/src/app/interfaces/authentication';
import { Observable } from 'rxjs';
import { IRawSession, ITokenRefresh } from 'projects/common/src/app/interfaces/remote-models';
import { HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements IAuthentication<ISession>, IExposeAuthentication<ISession> {

  constructor() { }

  public onTokenRefresh: () => Observable<ISession>;
  public sessionId: () => number;
  public isAuth: () => boolean;
  public cleanSession: () => Promise<boolean>;
  public cleanSessionCode: (code: string, params?: any) => Promise<boolean>;
  public registerSession: (tokenObject: IRawSession) => Promise<boolean>;
  public refreshToken: () => Observable<any>;
  public authorizeRequest: (arg0: HttpRequest<any>) => HttpRequest<any>;

  public getSession: () => ISession;
  public getToken: () => string;
  public getRefreshToken: () => string;
  public getTokenObject: () => ITokenRefresh;
}
